
<div>
  <label>{{label}}</label>
  <p>{{vat}}</p>
</div>
<div *ngIf="(secondaryLabel && (secondaryVat))">    
  <label>{{secondaryLabel}}</label>
  <p>{{secondaryVat}}</p>
</div>